import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-simple-input',
  templateUrl: './simple-input.component.html',
  styleUrls: ['./simple-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleInputComponent {
  @Input('color') color: ThemePalette;
  @Input('text') text: string = 'Placeholder text';
  @Input('placeholder') placeholder: string = 'Placeholder text';
}
